/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedContactDealerButton_user$ref = any;
type PdpSharedContactSupportButton_user$ref = any;
type PdpSharedMakeOfferButton_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarContact_user$ref: FragmentReference;
export type PdpRespSidebarContact_user = {|
  +isVerifiedTrade: ?boolean,
  +$fragmentRefs: PdpSharedContactDealerButton_user$ref & PdpSharedMakeOfferButton_user$ref & PdpSharedContactSupportButton_user$ref,
  +$refType: PdpRespSidebarContact_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSupportButton_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4b83d41a88b3b1a2e34e695fc81f1569';
module.exports = node;
